import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { MAGIC_TEXT_DEBOUNCE_FOR_SR } from "../constants";
export const useCharacterCount = (elementRef, excludedTextContent = "") => {
    const [characterCount, setCharacterCount] = useState(0);
    const [screenReaderCharacterCount, setScreenReaderCharacterCount] = useState(characterCount);
    useEffect(() => {
        const element = elementRef.current;
        if (element === null) {
            return;
        }
        // Screen reader live region updates on a delay so content is read properly (politely)
        const updateScreenReaderCharacterCount = debounce(setScreenReaderCharacterCount, MAGIC_TEXT_DEBOUNCE_FOR_SR);
        // Set both counts together
        const updateCharacterCounts = (text) => {
            const count = text.replace(excludedTextContent, "").trim().length;
            if (process.env.NODE_ENV === "test") {
                setScreenReaderCharacterCount(count);
            }
            else {
                updateScreenReaderCharacterCount(count);
            }
            setCharacterCount(count);
        };
        // Handle Character count for Textarea and Input fields
        if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            const updateCharacterCount = () => updateCharacterCounts(element.value);
            element.addEventListener("input", updateCharacterCount);
            updateCharacterCount();
            return () => {
                element.removeEventListener("input", updateCharacterCount);
                updateScreenReaderCharacterCount.cancel();
            };
        }
        // Handle Character count for non-input fields (SlateRTE, etc)
        const updateCharacterCount = () => updateCharacterCounts(element.textContent || "");
        const observer = new MutationObserver(updateCharacterCount);
        observer.observe(element, { subtree: true, childList: true, characterData: true });
        updateCharacterCount();
        return () => {
            observer.disconnect();
            updateScreenReaderCharacterCount.cancel();
        };
    }, [elementRef, excludedTextContent]);
    return { characterCount, screenReaderCharacterCount };
};
